module.exports = __webpack_public_path__ + "static/desktop/img/material-2.3e7a9c37.jpg";